/**********************************************************
 FIXED AJAX PRODUCT SWITCH + CLEAN URL UPDATE (ONE TIME)
**********************************************************/

// Global persistent flags
window.selected_size = false;
window._multiColorDocEventsBound = false;
window.nextProductUrl = null;
window._urlUpdatedThisRender = false;

function multiColor() {

  /*************************************
   1. Extract all size values
  *************************************/
  window.all_size_values = Array.from(
    new Set(
      (window.color_products || []).flatMap(product =>
        (product.variants || []).flatMap(variant =>
          [variant.option1, variant.option2, variant.option3]
        )
      ).filter(v => !!v && isLikelySize(v))
    )
  );

  /*************************************
   2. Bind document-level events ONCE
  *************************************/
  if (!window._multiColorDocEventsBound) {
    window._multiColorDocEventsBound = true;

    /* After AjaxLoader finished loading raw HTML */
    document.addEventListener("ajaxloader:load", function () {
      document.querySelectorAll('a')
        .forEach(link => link.setAttribute('data-ajaxloader', 'false'));

      if (AjaxLoader.supported) AjaxLoader.clearCache();

      document.dispatchEvent(new CustomEvent("product:page:loaded"));

      if (window.inventory_details) {
        for (let i in window.inventory_details) {
          const inp = document.querySelector(`input[name="Size"][value="${i}"]`);
          if (inp) {
            const inv = inp.nextElementSibling?.querySelector(".inventory-count");
            if (inv) inv.innerText = window.inventory_details[i];
          }
        }
      }
    });

    /* Before navigation begins */
    document.addEventListener("ajaxloader:before-visit", function () {
      $("#color-loader").show();
      document.dispatchEvent(new CustomEvent("product:before:page:load"));
    });

    /* Track selected size during variant change */
    document.addEventListener("product:variant:changed", trackVariantChangeEvent);

    /* AFTER AJAX RENDER — THIS IS WHERE WE UPDATE URL SAFELY */
    document.addEventListener("ajaxloader:render", function () {

      $("#loader").hide();
      reRenderItems();
      setTimeout(() => $("#color-loader").hide(), 800);

      applyHeaderScrollAdjustment();

      document.dispatchEvent(new CustomEvent(
        "product:variant:changed:hide:unavailable:variant",
        { detail: { init: true } }
      ));

      /*************************************
       ⭐ URL UPDATE — ONLY ONCE
      *************************************/
      if (!window._urlUpdatedThisRender && window.nextProductUrl) {
        history.pushState({}, "", window.nextProductUrl);
        window._urlUpdatedThisRender = true;
        window.nextProductUrl = null;
      }

      /* Reload Judge.me widget */
      const po = document.createElement('script');
      po.type = "text/javascript";
      po.async = false;
      po.src = "https://cdn.judge.me/loader.js";
      const s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(po, s);
    });
  }

  /*************************************
   3. Re-bind per-page DOM listeners
  *************************************/

  // Size selection
  document.querySelectorAll('.option-size input[name="Size"]').forEach(radio => {
    radio.onchange = function () {
      window.selected_size = this.value;
    };
  });

  // Color selection → go to product
  document.querySelectorAll("input[data-color-swatch]").forEach(radio => {
    radio.onchange = function () {
      const handle = this.getAttribute("data-procuct-handle");

      // Remove old variant listener for previous product
      document.removeEventListener("product:variant:changed", trackVariantChangeEvent);

      const url = getNavigationUrl(handle);

      /*************************************
       ⭐ PRE-ORDER FIX
       The Pre-order app (and anything else that only
       initialises on a real page load) never gets a chance to
       run against an AJAX-swapped product, because AjaxLoader
       swaps content in place instead of doing a full navigation.
       If the target colour is a Pre-Order product, send the
       browser to a real page load instead of the AJAX swap so
       those page-load-only scripts initialise correctly.
      *************************************/
      const targetProduct = (window.color_products || []).find(p => p.handle === handle);
      const isPreorder = !!(targetProduct && Array.isArray(targetProduct.tags) &&
        targetProduct.tags.some(t => String(t).toLowerCase() === 'pre-order'));

      if (isPreorder) {
        window.location.href = url;
        return;
      }

      goToProduct(url);
    };
  });

  applyHeaderScrollAdjustment();
}

/**********************************************************
 TRACK VARIANT CHANGE (For size matching)
**********************************************************/
function trackVariantChangeEvent(e) {
  const variant = e.detail.variant;
  if (!variant) return;

  const selectedSize =
    [variant.option1, variant.option2, variant.option3]
      .find(v => window.all_size_values.includes(v));

  if (!window.selected_size) return;

  window.color_options = { size: selectedSize };
}

/**********************************************************
 FIX HEADER SCROLL OFFSET
**********************************************************/
var _headerAdjustmentInitialized = false;
function applyHeaderScrollAdjustment() {
  $(document).off("scroll.adjustHeader");
  $(document)
    .on("scroll.adjustHeader", function () {
      const announ = document.querySelector('.announcement-bar-section');
      const header = document.querySelector('.section-header');
      const main = document.querySelector('#MainContent');

      if (announ && header && main) {
        announ.style.top = "0px";
        header.style.top = announ.offsetHeight + "px";
        main.style.paddingTop = announ.offsetHeight + "px";
      }
    });
  if (!_headerAdjustmentInitialized) {
    _headerAdjustmentInitialized = true;
    $(document).trigger("scroll");
  }
}

/**********************************************************
 RE-CLONE ELEMENTS THAT LOSE JS BINDINGS AFTER AJAX LOAD
**********************************************************/
function reRenderItems() {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer && cartDrawer.parentNode) {
    cartDrawer.parentNode.replaceChild(cartDrawer.cloneNode(true), cartDrawer);
  }

  const productForm = document.querySelector("product-form");
  if (productForm && productForm.parentNode) {
    productForm.parentNode.replaceChild(productForm.cloneNode(true), productForm);
  }

  setTimeout(() => {
    const productEl = document.querySelector("variant-selects");
    const product_id = productEl?.getAttribute("data-product-id");
  }, 3000);
}

/**********************************************************
 AJAX NAVIGATION CONTROLLER
**********************************************************/
function goToProduct(url = null) {
  if (!url) return;

  // Reset URL update lock
  window._urlUpdatedThisRender = false;

  // Save URL to update after render
  window.nextProductUrl = url;

  if (AjaxLoader.supported) {
    AjaxLoader.visit(url);
  } else {
    window.location.href = url;
  }
}

/**********************************************************
 BUILD CORRECT PRODUCT + VARIANT URL
**********************************************************/
function getNavigationUrl(handle = null) {
  if (!handle) return null;

  let url = `/products/${handle}`;

  if (window.color_options?.size && Array.isArray(window.color_products)) {
    for (const pro of window.color_products) {
      if (pro.handle === handle) {
        for (const vari of pro.variants) {
          if ([vari.option1, vari.option2, vari.option3].includes(window.color_options.size)) {
            url += `?variant=${vari.id}`;
            break;
          }
        }
        break;
      }
    }
  }

  return url;
}

/**********************************************************
 CHECK IF VALUE LOOKS LIKE A SIZE
**********************************************************/
function isLikelySize(value) {
  const patterns = [
    /^[0-9]{1,2}$/,                      // numeric sizes (6, 10, 18)
    /^(2XS|XS|S|M|L|XL|2XL|3XL)$/i       // letter sizes
  ];
  return patterns.some(p => p.test(value));
}

/**********************************************************
 INIT
**********************************************************/
multiColor();

document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("product:variant:changed:scriptrender", () => {
    multiColor();
  });
});
